query ReadCategory(
    $id: ID!
) {
    # Display copy — English when the category has it. `categorySource` below is
    # the editable document and deliberately keeps every language.
    category(id: $id) {
        icon
        name(language: "en") {
            language
            text
        }
    }
    additionalCategoryData: category(id: $id) {
        id

        public

        parentCategory {
            id

            name(language: "en") {
                text
            }
        }

        bimClasses(tag: "latest") {
            id
            revisionID
        }
    },
    categorySource: category(id: $id) {
        id
        name {
            language
            text
        }
        public
        icon
    }
}
